<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div v-if="!data.forgetPage" class="card-body">
                <h1>Login</h1>
                <p v-bind:class="{ 'text-muted': !data.loginError, 'error-text': data.loginError }">{{data.loginMessage}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-envelope"></i></span>
                  <input v-model="data.body.username" type="text" class="form-control" placeholder="Email">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input v-model="data.body.password" type="password" class="form-control" placeholder="Password">
                </div>
                <div class="row">
                  <div class="col-6">
                    <button v-on:click="login()" type="button" class="btn btn-primary px-4">Login</button>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" v-on:click="switchToForgetPage()" class="btn btn-link px-0">Forgot password?</button>
                  </div>
                </div>
              </div>
              <div v-if="data.forgetPage" class="card-body">
                <h1>Forget Password</h1>
                <p v-bind:class="{ 'text-muted': !data.forgetError, 'error-text': data.forgetError }">{{data.forgetMessage}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-envelope"></i></span>
                  <input v-model="data.body.username" type="text" class="form-control" placeholder="Email">
                </div>
                <div class="row">
                  <div v-if="data.showMailButton" class="col-6">
                    <button v-on:click="forgetPassword()" type="button" class="btn btn-primary px-4">Send Mail</button>
                  </div>
                  <div v-if="data.showMailButton" class="col-6 text-right">
                    <button v-on:click="switchToLoginPage()" type="button" class="btn btn-link px-0">Cancel</button>
                  </div>
                  <div class="card-body">
                    <div v-if="!data.showMailButton">
                      <p><span class="success-text">An email has been sent with instructions on how to reset your password. It may take a few minutes to arrive. If you do not receive it, please check your spam filter.</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card text-white bg-dark py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <img src="./wc.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      context: 'login context',
      data: {
        body: {
          username: '',
          password: ''
        },
        loginMessage: 'Sign in to your account.',
        loginError: false,
        forgetPage: false,
        forgetError: false,
        forgetMessage: 'Enter your e-mail address so we can send you a password reset request',
        showMailButton: true
      },
      error: null
    }
  },
  methods: {
    login () {
      this.$auth.login({
        body: this.data.body,
        redirect: '/dashboard',
        success (res) {
          console.log('success -> res.body.data', res.body.data)
          this.$auth.token(null, res.body.data.id)
          this.$auth.user(res.body.data)
        },
        error (res) {
          this.data.loginError = true
          this.data.loginMessage = res.body.message
          this.$auth.logout()
        }
      })
    },
    forgetPassword () {
      // hide show send mail button
      this.data.showMailButton = false
      this.data.forgetMessage = 'Enter your e-mail address so we can send you a password reset request'
      this.data.forgetError = false
      if (this.data.body.username === null || this.data.body.username === '') {
        this.data.forgetError = true
        this.data.forgetMessage = 'Please enter email Id.'
        this.data.showMailButton = true
      } else {
        this.$http.post('auth/sendForgetMail', {'username': this.data.body.username}).then(response => {
          // console.log(response)
          if (response.body.message && response.body.message.message) {
            this.data.forgetMessage = 'This e-mail address is not currently registered.'
            this.data.forgetError = true
            this.data.showMailButton = true
          }
        }, response => {
          console.log(response)
        })
      }
    },
    switchToLoginPage () {
      // switch to login tab
      this.data.forgetPage = false
    },
    switchToForgetPage () {
      // switch to forget tab
      this.data.forgetPage = true
    }
  }
}
</script>

<style>
  .error-text {
    color: red;
  }
  .success-text {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?2c88af52